import { render } from "./indexHeader.vue?vue&type=template&id=2af5076b&scoped=true"
import script from "./indexHeader.vue?vue&type=script&lang=js"
export * from "./indexHeader.vue?vue&type=script&lang=js"

import "./indexHeader.vue?vue&type=style&index=0&id=2af5076b&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-2af5076b"

export default script